import { NavLink, Outlet } from 'react-router-dom';

export function Capture() {
  return (
    <div>
      <div className="tab-bar">
        <NavLink
          to="/capture/transcript"
          className={({ isActive }) => `tab${isActive ? ' active' : ''}`}
        >
          Transcript
        </NavLink>
        <NavLink
          to="/capture/articles"
          className={({ isActive }) => `tab${isActive ? ' active' : ''}`}
        >
          Articles
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
}
